'use strict';

var ChartScheduleFilterFactory = function ChartScheduleFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['MarketsFilterByMarketFactory', 'SchedulesFilterByMonthsFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function ChartScheduleFilter() {
    DemandFilter.call(this, 'market-dashboard', 'dashboard-schedule');
    this.registerFilters(injectedFilters);
  }
  ChartScheduleFilter.prototype = Object.create(DemandFilter.prototype);
  ChartScheduleFilter.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  return ChartScheduleFilter;
};
ChartScheduleFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = ChartScheduleFilterFactory;